import { MOCK_DATA } from './mockData';

class DemoBackend {
    constructor() {
        this.data = JSON.parse(JSON.stringify(MOCK_DATA)); // Deep copy to ensure fresh state on init
        this.currentUser = this.data.users[0];
    }

    // Main entry point for interception
    async handleRequest(config) {
        let { url, method, data, params } = config;
        method = method.toLowerCase(); // Normalize method
        console.log(`[DemoBackend] ${method.toUpperCase()} ${url}`, config);

        await new Promise(resolve => setTimeout(resolve, 300)); // Simulate network latency

        const body = data ? (typeof data === 'string' ? JSON.parse(data) : data) : {};

        // --- ROUTING LOGIC ---

        // 1. Dashboard
        if (url === '/dashboard' && method === 'get') {
            return { data: this.getDashboardData() };
        }

        // 2. Wallets
        if (url === '/wallets' && method === 'get') return { data: this.data.wallets };
        if (url === '/wallets' && method === 'post') return { data: this.createItem('wallets', body) };
        if (url.startsWith('/wallets/') && method === 'patch') return { data: this.updateItem('wallets', url, body) };
        if (url.startsWith('/wallets/') && method === 'delete') return { data: this.deleteItem('wallets', url) };

        // 3. Projects
        if (url === '/projects' && method === 'get') {
            return { data: this.getProjectsWithStats() };
        }
        if (url === '/projects' && method === 'post') return { data: this.createItem('projects', body) };
        if (url.startsWith('/projects/') && method === 'patch') return { data: this.updateItem('projects', url, body) };
        if (url.startsWith('/projects/') && method === 'delete') return { data: this.deleteItem('projects', url) };

        // 4. Transactions
        if (url === '/transactions' || url === '/api/transactions') {
            if (method === 'get') return { data: this.getTransactions(params) };
            if (method === 'post') return { data: this.createTransaction(body) };
        }
        if (url.startsWith('/transactions/') || url.startsWith('/api/transactions/')) {
            if (method === 'delete') return { data: this.deleteItem('transactions', url) };
            if (method === 'put' || method === 'patch') return { data: this.updateItem('transactions', url, body) };
        }

        // Mocked task data
        if (url === '/tasks' && method === 'get') return { data: this.data.tasks };
        if (url === '/tasks' && method === 'post') return { data: this.createItem('tasks', body) };

        if (url === '/settings' && method === 'get') return {
            data: {
                company_name: 'Демо Компания',
                currency_symbol: '₽',
                dashboard_date_range: 'this_month',
                dashboard_widgets: 'balance,charts,wallets,tasks,recent_transactions'
            }
        };
        if (url === '/settings' && method === 'post') return { data: { status: 'ok' } };
        if (url === '/settings/bot-status' && method === 'get') return { data: { status: 'stopped', username: 'demo_bot' } };
        if (url === '/settings/logo' && method === 'post') return { data: { url: 'https://placehold.co/100x100?text=Logo' } };

        if (url === '/users' && method === 'get') return { data: this.data.users };
        if (url === '/users' && method === 'post') return { data: this.createItem('users', body) };
        if (url.startsWith('/users/') && method === 'patch') return { data: this.updateItem('users', url, body) };
        if (url.startsWith('/users/') && method === 'delete') return { data: this.deleteItem('users', url) };

        if (url === '/categories' && method === 'get') return { data: this.data.categories };
        if (url === '/categories' && method === 'post') return { data: this.createItem('categories', body) };
        if (url.startsWith('/categories/') && method === 'delete') return { data: this.deleteItem('categories', url) };

        if (url === '/logs' && method === 'get') {
            const logsWithUsers = this.data.logs.map(log => {
                const user = this.data.users.find(u => u.id === log.user_id);
                return { ...log, user: user ? user.name : 'Unknown' };
            });
            return { data: logsWithUsers };
        }

        // 7. Planning
        if (url === '/planning' && method === 'get') return { data: this.data.planning };
        if (url === '/planning' && method === 'post') return { data: this.createItem('planning', body) };
        if (url.startsWith('/planning/') && method === 'put') return { data: this.updateItem('planning', url, body) };
        if (url.startsWith('/planning/') && method === 'delete') return { data: this.deleteItem('planning', url) };

        // 8. Inventory
        if (url === '/inventory' && method === 'get') return { data: this.data.inventory };
        if (url === '/inventory' && method === 'post') return { data: this.createItem('inventory', body) };
        if (url.startsWith('/inventory/') && method === 'patch') return { data: this.updateItem('inventory', url, body) };
        if (url.startsWith('/inventory/') && method === 'delete') return { data: this.deleteItem('inventory', url) };

        // 9. Clients
        if (url === '/clients' && method === 'get') return { data: this.data.clients };
        if (url === '/clients' && method === 'post') return { data: this.createItem('clients', body) };
        if (url.startsWith('/clients/') && method === 'patch') return { data: this.updateItem('clients', url, body) };
        if (url.startsWith('/clients/') && method === 'delete') return { data: this.deleteItem('clients', url) };

        // 9. Transfer
        if (url === '/transfer' && method === 'post') return { data: this.handleTransfer(body) };

        // 10. Services & Tariffs
        if (url === '/api/services-tariffs/services' && method === 'get') return { data: this.data.services };
        if (url === '/api/services-tariffs/services' && method === 'post') return { data: this.createItem('services', body) };
        if (url.startsWith('/api/services-tariffs/services/') && method === 'patch') return { data: this.updateItem('services', url, body) };
        if (url.startsWith('/api/services-tariffs/services/') && method === 'delete') return { data: this.deleteItem('services', url) };
        if (url === '/api/services-tariffs/tariffs' && method === 'get') return { data: this.data.tariffs };
        if (url === '/api/services-tariffs/tariffs' && method === 'post') return { data: this.createItem('tariffs', body) };
        if (url.startsWith('/api/services-tariffs/tariffs/') && method === 'patch') return { data: this.updateItem('tariffs', url, body) };
        if (url.startsWith('/api/services-tariffs/tariffs/') && method === 'delete') return { data: this.deleteItem('tariffs', url) };

        // 11. Invoices
        if (url === '/invoices' && method === 'get') return { data: this.data.invoices };
        if (url === '/invoices' && method === 'post') {
            const inv = { id: Date.now(), number: `INV-${Date.now().toString().slice(-4)}`, paid_amount: 0, status: 'Ожидает', ...body };
            const cl = this.data.clients.find(c => c.id === parseInt(inv.client_id));
            const pr = this.data.projects.find(p => p.id === parseInt(inv.project_id));
            inv.client_name = cl ? cl.name : '';
            inv.project_name = pr ? pr.name : '';
            inv.amount = parseFloat(inv.amount) || 0;
            this.data.invoices.push(inv);
            return { data: inv };
        }
        if (url.match(/\/invoices\/\d+\/pay/) && method === 'post') {
            const invId = parseInt(url.split('/')[2]);
            const inv = this.data.invoices.find(i => i.id === invId);
            if (inv) {
                const payAmount = parseFloat(body.amount) || 0;
                inv.paid_amount += payAmount;
                inv.status = inv.paid_amount >= inv.amount ? 'Оплачен' : 'Частично';
            }
            return { data: { status: 'ok' } };
        }
        if (url.startsWith('/invoices/') && method === 'delete') return { data: this.deleteItem('invoices', url) };

        // 12. Auth
        if (url === '/me' && method === 'get') return { data: this.currentUser };

        // Fallback
        console.warn(`[DemoBackend] Unhandled request: ${method} ${url}`);
        return { data: [] };
    }

    // --- HELPERS ---

    createItem(collection, item) {
        const newItem = { id: Date.now(), ...item };
        if (!this.data[collection]) this.data[collection] = [];
        this.data[collection].push(newItem);
        return newItem;
    }

    updateItem(collection, url, updates) {
        const id = parseInt(url.split('/').pop());
        const item = this.data[collection].find(i => i.id === id);
        if (item) {
            Object.assign(item, updates);
        }
        return { status: 'ok', id };
    }

    deleteItem(collection, url) {
        const id = parseInt(url.split('/').pop());
        this.data[collection] = this.data[collection].filter(i => i.id !== id);
        return { status: 'ok' };
    }

    getProjectsWithStats() {
        return this.data.projects.map(p => {
            const txs = this.data.transactions.filter(t => t.project_id === p.id);
            const income = txs.filter(t => t.type === 'Доход').reduce((sum, t) => sum + t.amount, 0);
            const expense = txs.filter(t => t.type === 'Расход').reduce((sum, t) => sum + t.amount, 0);
            const profit = income - expense;
            return {
                ...p,
                income, expense, profit,
                net_profit: profit,
                margin: income > 0 ? (profit / income) * 100 : 0,
                tasks_count: this.data.tasks.filter(t => t.project_name === p.name).length
            };
        });
    }

    createTransaction(data) {
        const amount = parseFloat(data.amount);
        const wallet = this.data.wallets.find(w => w.id === parseInt(data.wallet_id));

        const targetWallet = wallet || this.data.wallets[0];

        const newTx = {
            id: Date.now(),
            date: data.date || new Date().toISOString(),
            created_by: this.currentUser.id,
            ...data,
            wallet_id: targetWallet.id,
            amount: amount,
            project_id: data.project_id ? parseInt(data.project_id) : null
        };

        if (!this.data.transactions) this.data.transactions = [];
        this.data.transactions.push(newTx);

        if (newTx.type === 'Доход') targetWallet.balance += amount;
        if (newTx.type === 'Расход') targetWallet.balance -= amount;

        return { status: 'ok', id: newTx.id };
    }

    getTransactions(params) {
        let res = [...this.data.transactions].sort((a, b) => new Date(b.date) - new Date(a.date));
        return res.map(t => {
            const w = this.data.wallets.find(w => w.id === t.wallet_id);
            const p = this.data.projects.find(pr => pr.id === t.project_id);
            return {
                ...t,
                wallet_name: w ? w.name : 'Unknown',
                project_name: p ? p.name : ''
            };
        });
    }

    getChartData() {
        // Aggregate transactions by date
        const dailyData = {};
        const today = new Date();
        const start = new Date();
        start.setDate(today.getDate() - 30);

        // Init last 30 days
        for (let d = new Date(start); d <= today; d.setDate(d.getDate() + 1)) {
            const dateStr = d.toISOString().split('T')[0];
            dailyData[dateStr] = { date: dateStr, income: 0, expense: 0 };
        }

        this.data.transactions.forEach(t => {
            const dateStr = t.date.split('T')[0];
            if (dailyData[dateStr]) {
                if (t.type === 'Доход') dailyData[dateStr].income += t.amount;
                if (t.type === 'Расход') dailyData[dateStr].expense += t.amount;
            }
        });

        return Object.values(dailyData);
    }

    getDashboardData() {
        const projects = this.getProjectsWithStats();
        const txs = this.data.transactions;
        const income = txs.filter(t => t.type === 'Доход').reduce((sum, t) => sum + t.amount, 0);
        const expense = txs.filter(t => t.type === 'Расход').reduce((sum, t) => sum + t.amount, 0);

        return {
            wallets: this.data.wallets,
            hot_tasks: this.data.tasks.filter(t => t.priority === 'Critical' || t.priority === 'High'),
            tasks: this.data.tasks.slice(0, 10),
            recent_transactions: this.getTransactions().slice(0, 5),
            total_income: income,
            total_expense: expense,
            total_balance: this.data.wallets.reduce((sum, w) => sum + w.balance, 0),
            chart_data: this.getChartData()
        };
    }

    handleTransfer(data) {
        const fromWallet = this.data.wallets.find(w => w.id === parseInt(data.from_wallet_id));
        const toWallet = this.data.wallets.find(w => w.id === parseInt(data.to_wallet_id));
        const amount = parseFloat(data.amount);

        if (!fromWallet || !toWallet) throw { response: { status: 400, data: { detail: 'Wallet not found' } } };
        if (fromWallet.balance < amount) throw { response: { status: 400, data: { detail: 'Insufficient funds' } } };

        fromWallet.balance -= amount;
        toWallet.balance += amount;

        const date = new Date().toISOString();
        if (!this.data.transactions) this.data.transactions = [];
        this.data.transactions.push({ id: Date.now(), type: 'Расход', amount, wallet_id: fromWallet.id, category: 'Перевод', notes: `Перевод на ${toWallet.name}. ${data.notes || ''}`, date, created_by: this.currentUser.id });
        this.data.transactions.push({ id: Date.now() + 1, type: 'Доход', amount, wallet_id: toWallet.id, category: 'Перевод', notes: `Перевод от ${fromWallet.name}. ${data.notes || ''}`, date, created_by: this.currentUser.id });

        return { status: 'ok' };
    }
}

// Singleton instance
export const demoBackend = new DemoBackend();
